
import React from 'react';

const Imprint: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-4 bg-gray-50">
        <div className="container mx-auto">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl font-bold mb-6">Impressum</h1>
            <p className="text-gray-600 text-lg">
              Gesetzliche Informationen über den Betreiber dieser Website.
            </p>
          </div>
        </div>
      </section>
      
      {/* Imprint Content */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-3xl">
          <div className="prose prose-lg max-w-none">
            <h2>Angaben gemäß § 5 TMG</h2>
            <p>
              A.B.S. GmbH - Gebäudesanierung und Renovierung<br />
              Talweg 2G<br />
              85614 Kirchseeon
            </p>
            <br/>
            
            <h3>Vertreten durch</h3>
            <p>
              Rexhe Xhakmani und Jahir Gashi<br />
              Geschäftsführer
            </p>
            <br/>
            
            <h3>Kontakt</h3>
            <p>
              Telefon: +4917657122695<br />
            </p>
            <br/>

            <h3>Umsatzsteuer-ID: DE366998736</h3>
            <br/>

            <h2>Haftungsausschluss</h2>
            
            <h3>Haftung für Inhalte</h3>
            <p>
              Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <br/>
            
            <h3>Haftung für Links</h3>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Imprint;
